import { BsBox2Fill } from "react-icons/bs";
import { InputField } from "@/components";
import { useFieldError } from "@/";

const OtherDetails = ({ data, setData, errors ,isDisabled = false}) => {
  const getErrorMessage = useFieldError(errors);

  const handleChange = (key, value) => {
    setData((prev) => ({ ...prev, [key]: value }));
  };

  const handleDimensionsChange = (key, value) => {
    setData((prev) => ({
      ...prev,
      dimensions: { ...prev.dimensions, [key]: value },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevents unwanted page refresh
    console.log("Submitted Data:", data);
  };

  return (
    <div className="w-full h-fit flex flex-col gap-2 border-2 border-secondary/30 rounded-2xl p-4">
      <div className="flex gap-2 items-center">
        <BsBox2Fill className="text-headline4 text-secondary/80" />
        <h2 className="text-headline4 text-secondary/80 font-nunito font-semibold">
          Other Details
        </h2>
      </div>
      <form onSubmit={handleSubmit} className="flex flex-col md:flex-row gap-2">
        <InputField
          type="number"
          label="Physical Weight (in kg)"
          placeholder="Enter Physical Weight"
          value={data.physicalWeight}
          onChange={(value) => handleChange("physicalWeight", value)}
          error={getErrorMessage("physicalWeight")}
          disabled={isDisabled}
        />
        <InputField
          type="number"
          label="Length (in cm)"
          placeholder="Enter Length"
          value={data.dimensions.length}
          onChange={(value) => handleDimensionsChange("length", value)}
          error={getErrorMessage("dimensions.length")}
          disabled={isDisabled}
        />
        <InputField
          type="number"
          label="Breadth (in cm)"
          placeholder="Enter Breadth"
          value={data.dimensions.breadth}
          onChange={(value) => handleDimensionsChange("breadth", value)}
          error={getErrorMessage("dimensions.breadth")}
          disabled={isDisabled}
        />
        <InputField
          type="number"
          label="Height (in cm)"
          placeholder="Enter Height"
          value={data.dimensions.height}
          onChange={(value) => handleDimensionsChange("height", value)}
          error={getErrorMessage("dimensions.height")}
          disabled={isDisabled}
        />
      </form>
    </div>
  );
};

export default OtherDetails;
